import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';

import Form from '../Form';

const MARKET_SUBTYPES = [
    {
        id: 'regular',
        label: 'Standard',
    },

    {
        id: 'line',
        label: 'Line',
    },
];

class MarketTemplateCreationForm extends Form {
    static fieldsValidation = {
        name: ['required'],
        eventTemplateId: ['required'],
        marketSubtype: ['required'],
    };

    static propTypes = {
        ...Form.propTypes,
        eventTemplates: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.string.isRequired,
                label: PropTypes.string.isRequired,
            })
        ),

        onSubmit: PropTypes.func,
    };

    static defaultProps = {
        ...Form.defaultProps,

        eventTemplates: List(),
    };

    constructor(props, context) {
        super(props, context);
    }

    onSubmit(event) {
        event.preventDefault();

        Form.prototype.onSubmit.call(this, event);
    }

    renderSelect(name, options = []) {
        return this.getField(
            <select {...this.getFieldParameters(name)}>
                {options.map((item) => (
                    <option
                        key={item.id}
                        value={item.id}
                    >
                        {item.label}
                    </option>
                ))}
            </select>
        );
    }

    renderForm() {
        const { eventTemplates } = this.props;

        return (
            <div className='market-template-creation'>
                {this.getField(
                    <input
                        type='text'
                        label='Name'
                        {...this.getFieldParameters('name')}
                    />,
                    'You can use the following placeholders in name ' + '${home} ${away} ${line} ${opposite-line}'
                )}

                {this.renderSelect('marketSubtype', MARKET_SUBTYPES)}

                {this.renderSelect('eventTemplateId', eventTemplates)}

                <button
                    onClick={this.onSubmit.bind(this)}
                    className='btn btn-add'
                >
                    Save market template
                </button>
            </div>
        );
    }
}

export default MarketTemplateCreationForm;
